import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';

export const ErrorState = ({ onRetry }) => (
  <Card className="p-10 rounded-2xl border-red-100 dark:border-red-900/50 flex flex-col items-center gap-3 text-center" data-testid="error-state">
    <AlertCircle className="w-12 h-12 text-red-400" />
    <p className="text-sm text-muted-foreground">Impossible de charger les données. Vérifie ta connexion.</p>
    <Button onClick={onRetry} data-testid="retry-button" className="bg-orange-500 hover:bg-orange-600 rounded-full font-semibold">Réessayer</Button>
  </Card>
);
